import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsLinkComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
    selector: 'app-footer-socialmedia-icons',
    templateUrl: './footer-socialmedia-icons.component.html',
    styleUrl: './footer-socialmedia-icons.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FooterSocialmediaIconsComponent implements OnInit {

  public componentData: CmsLinkComponent;

  constructor(public component: CmsComponentData<CmsLinkComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
}
